module.exports = __webpack_public_path__ + "img/mfms01.96a63633.png";